"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editModes = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _editingMode = _interopRequireDefault(require("./google-map-react/editing-mode"));

var _geojsonEditor = _interopRequireDefault(require("./react-map-gl/geojson-editor"));

var _baseMap = require("./base-map");

var _geojson = _interopRequireWildcard(require("./geojson"));

var _propTypes2 = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var editModes = {
  edit: 'EDIT',
  drawCircle: 'DRAW_CIRCLE',
  drawPolygon: 'DRAW_POLYGON'
};
exports.editModes = editModes;

var GeoJsonEditor = function GeoJsonEditor(_ref) {
  var features = _ref.features,
      featureStyle = _ref.featureStyle,
      editMode = _ref.editMode,
      onSelect = _ref.onSelect,
      onUpdate = _ref.onUpdate;

  var _useMapType = (0, _baseMap.useMapType)(),
      mapType = _useMapType.mapType,
      types = _useMapType.types;

  var style = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, _geojson.defaultStyle), featureStyle);
  }, [featureStyle]);

  if (mapType === types.google) {
    return /*#__PURE__*/_react["default"].createElement(_editingMode["default"], {
      mode: editMode,
      features: features,
      featureStyle: style,
      onSelect: onSelect,
      onUpdate: onUpdate
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_geojsonEditor["default"], {
    editMode: editMode,
    features: features,
    featureStyle: style,
    onSelect: onSelect,
    onUpdate: onUpdate
  });
};

GeoJsonEditor.propTypes = {
  features: _propTypes["default"].oneOfType([(0, _propTypes2.FeatureCollectionShape)(), _propTypes["default"].arrayOf((0, _propTypes2.FeatureShape)()), (0, _propTypes2.FeatureShape)()]),
  featureStyle: _geojson["default"].propTypes.featureStyle,
  editMode: _propTypes["default"].oneOf(['EDIT', 'DRAW_CIRCLE', 'DRAW_POLYGON']),
  onSelect: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func
};

var noop = function noop() {};

GeoJsonEditor.defaultProps = {
  features: {
    type: 'FeatureCollection',
    features: []
  },
  featureStyle: _geojson["default"].defaultProps.featureStyle,
  editMode: null,
  onSelect: noop,
  onUpdate: noop
};
var _default = GeoJsonEditor;
exports["default"] = _default;